import * as ReactDOM from 'react-dom';

interface PortalProps {
	children: React.ReactNode;
	parentNode: Element;
}

const Portal = ({ children, parentNode }: PortalProps) => (
	ReactDOM.createPortal(children, parentNode)
);

export default Portal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Portal/index.tsx